import { StyledTagFilter } from '@src/containers/VoiceLibrary/Toolbar/index.style';
import React from 'react';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';

const FilterTags = ({
  keyName,
  options,
  dataFilterDraft,
  handleSelectFilter,
}) =>
  options?.map((item) => (
    <StyledTagFilter
      key={item.value}
      onClick={() => handleSelectFilter(keyName, item.value)}
      className={dataFilterDraft[keyName]?.includes(item.value) ? 'active' : ''}
    >
      <Typography
        variant="body-14-medium"
        color={
          dataFilterDraft[keyName]?.includes(item.value)
            ? COLOR.descriptionGray
            : COLOR.descriptionUpload
        }
      >
        {item.label}
      </Typography>
    </StyledTagFilter>
  ));

export default FilterTags;
